import React from 'react';
import { Navigate } from 'react-router-dom';
import Spinner from '../../../components/layout/Spinner';
import { useAuth } from '../../../contexts/AuthContext';
import { useUser } from '../../../contexts/UserContext';

export const PublicRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { user, loading } = useUser();

  if (isLoading || (isAuthenticated && loading)) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white">
        <Spinner />
      </div>
    );
  }

  if (isAuthenticated) {
    const redirectPath = user?.subscription_status === 'active' ? '/Application' : '/Pricing';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};



